/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { logControllerSearch } from '../fn/log/log-controller-search';
import { LogControllerSearch$Params } from '../fn/log/log-controller-search';
import { LogSearchResponseDto } from '../models/log-search-response-dto';

@Injectable({ providedIn: 'root' })
export class LogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `logControllerSearch()` */
  static readonly LogControllerSearchPath = '/api/log';

  /**
   * 로그 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `logControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  logControllerSearch$Response(params: LogControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<LogSearchResponseDto>> {
    return logControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 로그 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `logControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  logControllerSearch(params: LogControllerSearch$Params, context?: HttpContext): Observable<LogSearchResponseDto> {
    return this.logControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<LogSearchResponseDto>): LogSearchResponseDto => r.body)
    );
  }

}
